import { styled } from '@mui/material';

import { Button } from '@/components/Buttons/Button';

export const SelectorButton = styled(Button)(({ theme }) => ({
  paddingLeft: 8,
  paddingRight: 8,
  height: 24,
  marginRight: 8,
  backgroundColor: `${theme.palette.text.primary}33`,
  boxShadow: 'none',
  outline: 'none',
  '.MuiSvgIcon-root': {
    marginRight: 0
  },
  '.MuiTypography-root': {
    marginLeft: 4
  },
  '&:hover': {
    backgroundColor: `${theme.palette.text.primary}66`,
    boxShadow: 'none',
    outline: 'none'
  }
}));
